export default __webpack_public_path__ + "static/media/icon_test_acca.7ce31ebf.svg";